import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { DataSource, Raw, Repository } from "typeorm";
import { LocationsEntity } from "./locations.entity";
import { CommonResponseModel } from "@project-management-system/shared-models";
import { LocationsDto } from "./dto/locations-dto";
import { LocationsAdapter } from "./locations.adapter";


@Injectable()
export class LocationsService {
    constructor(
        @InjectRepository(LocationsEntity)

        private repo: Repository<LocationsEntity>,
        private readonly dataSource: DataSource,
        private adapter: LocationsAdapter,

    ) { }

    async getAllActiveLocations(): Promise<CommonResponseModel> {
        const data = await this.repo.find({ where: { isActive: true },order:{"locationName":"ASC"} });
        if (data) {
          return new CommonResponseModel(true, 1, "Data Retrived", data);
        } else {
          return new CommonResponseModel(false, 0, "Data Retrived");
        }
      }


      async getAllLocations(): Promise<CommonResponseModel> {
        const data = await this.repo.find({ order:{'locationName':'ASC'} });
        if (data) {
          return new CommonResponseModel(true, 1, "Data Retrived", data);
        } else {
          return new CommonResponseModel(false, 0, "Data Retrived");
        }
      }

  
      async getLocationWithoutRelation(location: string): Promise<LocationsEntity> {
        const locationResponse = await this.repo.findOne({
          where: { locationName: Raw(alias => `location_name = '${location}'`) },
        });
        if (locationResponse) {
          return locationResponse;
        }
        else {
          return null;
        }
      }
    
      async createLocation(loc: LocationsDto, isUpdate: boolean): Promise<CommonResponseModel> {
        try {
          console.log(isUpdate)
          let previousValue
          const locationsDtos: LocationsDto[] = [];
    
          if (!isUpdate) {
    
            const levelEntity = await this.getLocationWithoutRelation(loc.locationName);
            if (levelEntity) {
              // console.log(fabricsEntity,'------')
              throw new CommonResponseModel(false, 11104, 'Level already exists');
            }
          }
          else {
            const locationPrevious = await this.repo.findOne({ where: { id: loc.id } })
            previousValue = (locationPrevious.locationName)
            const locEntity = await this.getLocationWithoutRelation(loc.locationName);
            // console.log('ertyudfghjk============',certificatePrevious)
            if (locEntity) {
              if (locEntity.id != loc.id) {
                throw new CommonResponseModel(false, 11104, 'Location already exists');
              }
            }
          }
          const convertedlocationsEntity: LocationsEntity = this.adapter.convertDtoToEntity(loc, isUpdate);
    
          console.log(convertedlocationsEntity);
          const savedlocationEntity: LocationsEntity = await this.repo.save(convertedlocationsEntity);
          const savedlocationDto:LocationsDto = this.adapter.convertEntityToDto(savedlocationEntity);
          locationsDtos.push(savedlocationDto)
          if (savedlocationDto) {
            const presentValue = loc.locationName;
            const response = new CommonResponseModel(true, 1, isUpdate ? 'Location Updated Successfully' : 'Location Created Successfully')
            const name = isUpdate ? 'updated' : 'created'
            const displayValue = isUpdate ? 'Location Updated Successfully' : 'Location Created Successfully'
            const userName = isUpdate ? savedlocationDto.updatedUser : savedlocationDto.createdUser;
            return response;
          } else {
            throw new CommonResponseModel(false, 11106, 'Location saved but issue while transforming into DTO');
          }
        } catch (error) {
          return error;
        }
      }
    
}